export const propertyImagesSelector = (state) =>
    state.property.propertyImages;

export const propertyNotesSelector = (state) =>
    state.property.propertyNotes;
;
  